import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { ITechMapWorkType } from './interfaces';

export const getTechMapWorkTypeList = (data: IDynamicTableParams) => {
  return instance()
    .post<ITechMapWorkType[]>(`/techMap/workType/list`, data)
    .then((response) => response.data);
};

export const getTechMapWorkTypeAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>(`/techMap/workType/availableColumns`)
    .then((response) => response.data);
};

export const getTechMapWorkTypeAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>(`/techMap/workType/availableGroupColumns`)
    .then((response) => response.data);
};

export const loadTechMapWorkType = (workTypeId: number) => {
  return instance()
    .get<ITechMapWorkType>(`/techMap/workType/load/${workTypeId}`)
    .then((response) => response.data);
};

export const createTechMapWorkType = (techMapWorkType: ITechMapWorkType) => {
  return instance()
    .post<ITechMapWorkType>('/techMap/workType/save', techMapWorkType)
    .then((response) => response.data);
};

export const updateTechMapWorkType = (techMapWorkType: ITechMapWorkType) => {
  return instance()
    .post<ITechMapWorkType>(`/techMap/workType/${techMapWorkType.workTypeId}/update`, techMapWorkType)
    .then((response) => response.data);
};

export const archiveTechMapWorkType = (workTypeId: number) => {
  return instance()
    .post('/techMap/workType/archive', { workTypeId })
    .then((response) => response.data);
};

export const recoverTechMapWorkType = (workTypeId: number) => {
  return instance()
    .post('/techMap/workType/recover', { workTypeId })
    .then((response) => response.data);
};
